import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

@translate(['geozones'], { wait: true })
export class NoGeozones extends Component{
  render(){
    const { t } = this.props
    
    return (
      <div className="virtual-garage">
        <section className="garage-section garage-welcome">
          <h3 className="garage-section__title">{t('geozones:geozone_title')}</h3>
          <div className="garage-section__text">{t('geozones:new-geozone__description')}</div>
          <button type="button" className="button" onClick={this.props.handleAddClick}><span className="plus">+</span> {t('geozones:new-geozone__add')}</button>
        </section>
      </div>
    )
  }
}
  

NoGeozones.propTypes = {
    handleAddClick: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Dashboard/Geozones/NoGeozones.js